import React from 'react';

const INTRO_VIDEO_URL =
  'https://customer-assets.emergentagent.com/job_0ccb28be-9d0e-47e5-b6e8-e582afada5f3/artifacts/ut6271jw_intro-2.mp4';

const WelcomeSection = () => {
  return (
    <section
      className="section-padding"
      data-testid="welcome-video-section"
      style={{
        background:
          'linear-gradient(180deg, #0f0a1e 0%, #1a0e2e 50%, #0f0a1e 100%)',
      }}
    >
      <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
        <h2
          style={{
            fontSize: 'clamp(32px, 4vw, 48px)',
            fontWeight: 700,
            marginBottom: '20px',
          }}
        >
          Welcome to <span style={{ color: '#00d4ff' }}>Your Spiritual Journey</span>
        </h2>
        <p
          style={{
            fontSize: '16px',
            color: '#b0adc0',
            lineHeight: 1.8,
            maxWidth: '700px',
            margin: '0 auto 50px',
          }}
        >
          Inner Bridge integrates ancient wisdom with cutting-edge consciousness research,
          illuminating the path toward profound transformation and universal energy mastery.
        </p>

        {/* Intro Video Player */}
        <div
          style={{
            position: 'relative',
            width: '100%',
            borderRadius: '20px',
            overflow: 'hidden',
            background:
              'linear-gradient(135deg, rgba(88, 28, 135, 0.3), rgba(6, 182, 212, 0.1))',
            border: '1px solid rgba(139, 92, 246, 0.3)',
            aspectRatio: '16/9',
            boxShadow: '0 20px 60px rgba(139, 92, 246, 0.25)',
          }}
        >
          <video
            data-testid="intro-video-player"
            src={INTRO_VIDEO_URL}
            autoPlay
            muted
            loop
            playsInline
            controls
            preload="auto"
            style={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              background: '#000',
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
